export default __webpack_public_path__ + "static/d-feature-1-5c24526e3c2b7cf731c1d7e1311186df.png";